import React from "react";
import styles from './DropDown.styl';

function DropDown(props) {

	const {x, y, title, width = 140, labelWidth = 500, options, ...addProps} = props
	return (
		<div className={styles.selectWrapper} style={{top: y + 'px', left: x + 'px', zIndex: 10}}>
			{
				title ?
					<p className={styles.selectLabel} style={{maxWidth:labelWidth + 'px'}}>{title}</p>
					:
					null
			}

			<select
				className={styles.selectBase}
				style={{width:width + 'px'}}
				{...addProps}
			> {options.length > 0
				? options.map((option, index) => {
					return (
						<option value={option} key={index + option}>{option} </option>)
				})
				: <option value="Выбрать">Выбрать</option>
			}
			</select>
		</div>
	)

}

export default DropDown;




// WEBPACK FOOTER //
// ./src/react/ui/features/DropDown/DropDown.jsx